import React, { useState } from "react";
import LoginPassword from "./LoginPassword";
import Register from "./Register";
import Otp from "./Otp";
import ForgetPassword from "./ForgetPassword";

export default function Both({ currentScreen, setCurrentScreen, closeModal }) {
  const options = ["Password", "Otp"];
  const [formName, setFormName] = useState(options[0]);

  let content;
  if (currentScreen === "LOGIN") {
    content = (
      <div className="flex items-center gap-2 px-5 pt-4">
        {options.map((option, index) => (
          <button
            key={index}
            className={`px-5 py-2 text-sm font-semibold rounded-lg transition-all ${
              formName === option
                ? "bg-[#FFD338] text-[#052c24] border border-black shadow-[0px_4px_10px_rgba(0,0,0,0.3)]"
                : "bg-white text-[#052c24] border border-gray-300 hover:bg-gray-100"
            }`}
            onClick={() => setFormName(option)}
          >
            {option}
          </button>
        ))}
      </div>
    );
  }

  return (
    <>
      {content}

      {currentScreen === "FORGOT_PASSWORD" ? (
        <ForgetPassword changeScreen={setCurrentScreen} />
      ) : currentScreen === "REGISTER" ? (
        <Register changeScreen={setCurrentScreen} />
      ) : formName === options[0] && currentScreen === "LOGIN" ? (
        <LoginPassword
          changeScreen={setCurrentScreen}
          onClose={closeModal}
        />
      ) : formName === options[1] && currentScreen === "LOGIN" ? (
        <Otp changeScreen={setCurrentScreen} onClose={closeModal} />
      ) : (
        <p className="text-center text-gray-500 py-8">Unknown status.</p>
      )}
    </>
  );
}
